export default {
	ASSET_COLLECTION: 'Asset collection',
	ASSETS: 'Assets',
	PRODUCTS: 'Products',
	PRODUCT_VARIANTS: 'Product variants',
};
